const RNFetchBlob = {
    fetch: () => {
        console.warn('rn-fetch-blob is not supported for react-native-web. This is a mock implementation.');
        return Promise.resolve();
    },
};
export default RNFetchBlob;
